var _a, _b;
import { WINDOW_RESIZE } from '../actions';
export function BrowserReducer(state = initialState, action) {
    switch (action.type) {
        case WINDOW_RESIZE:
            return Object.assign(Object.assign({}, state), { windowHeight: action.payload.windowHeight, windowWidth: Math.min(1600, action.payload.windowWidth) });
        default:
            return state;
    }
}
const initialState = {
    windowHeight: (_a = window) === null || _a === void 0 ? void 0 : _a.innerHeight,
    windowWidth: Math.min(1600, (_b = window) === null || _b === void 0 ? void 0 : _b.innerWidth),
};
